export default "__VITE_ASSET__DqBeWalz__"